import MediaResource from './media-resource';

export default class Audio extends MediaResource {
  get defaultContentType() {
    return 'audio/x-m4a';
  }

  get resourceName() {
    return 'audio';
  }

  get resourcesName() {
    return 'audio';
  }

  get createAction() {
    return 'audio/upload';
  }

  async uploadTrack(file, attributes, progress) {
    const options = {
      method: 'POST',
      path: this.createAction,
      fields: {},
      files: {},
    };

    options.fields['audio[access_key]'] = attributes.access_key;
    options.files['audio[track]'] = file;
    // @ts-ignore
    options.progress = progress;

    const body = await this.call(options);

    return JSON.parse(body)[this.resourceName];
  }

  track(id, callback) {
    // @ts-ignore
    return this.call({ path: this.trackURL(id, 'json') }, callback);
  }

  audioURL(id) {
    return this.member(id, 'mp4');
  }

  trackURL(id, format) {
    return this.memberAction(id, 'track', format);
  }

  thumbnailURL(id) {
    return "";
  }
}
